import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';

export function SectionTitle({ children, className = '' }) {
  return (
    <div className={cn('text-[11px] font-semibold uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]', className)}>
      {children}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action, testid, compact = false }) {
  return (
    <div
      data-testid={testid}
      className={cn(
        'erak-card blueprint-grid relative flex flex-col items-center justify-center gap-4 overflow-hidden px-6 text-center',
        compact ? 'py-10' : 'py-16',
      )}
    >
      {/* Illustrated graphic — layered tokens, no external assets */}
      <div className="relative grid place-items-center">
        <div className="absolute h-28 w-28 rounded-full bg-[hsl(var(--copper)/0.12)] blur-2xl" aria-hidden="true" />
        <div className="absolute h-20 w-20 rounded-full border border-[hsl(var(--border))] opacity-60" aria-hidden="true" />
        {Icon && (
          <div className="relative grid h-16 w-16 place-items-center rounded-2xl border bg-card text-[hsl(var(--copper))] shadow-sm">
            <span className="absolute -right-2 -top-2 h-5 w-5 rounded-lg border bg-[hsl(var(--teal)/0.18)]" aria-hidden="true" />
            <span className="absolute -bottom-2 -left-2 h-4 w-4 rounded-md border bg-[hsl(var(--copper)/0.18)]" aria-hidden="true" />
            <Icon size={28} />
          </div>
        )}
      </div>
      <div className="space-y-1.5">
        <div className="font-display text-lg font-semibold">{title}</div>
        {description && <div className="mx-auto max-w-md text-sm text-muted-foreground">{description}</div>}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}

export function KpiCard({ label, children, sub, icon: Icon, accent = false, index = 0, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.06, ease: 'easeOut' }}
      data-testid={testid}
      className="erak-card p-5"
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-[hsl(var(--muted-foreground))]">{label}</div>
        {Icon && (
          <div className={cn('grid h-8 w-8 place-items-center rounded-lg', accent
            ? 'bg-[hsl(var(--copper)/0.16)] text-[hsl(var(--copper))]'
            : 'bg-[hsl(var(--teal)/0.14)] text-[hsl(var(--teal))]')}>
            <Icon size={16} />
          </div>
        )}
      </div>
      <div className="mt-3 font-display text-2xl font-bold md:text-3xl">{children}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </motion.div>
  );
}
